/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Authenticated user that explicitly resolved an assistance.
 */
export type EmployeeAssistanceUserResolutionActor = {
    type: EmployeeAssistanceUserResolutionActor.type;
    userId: string;
};
export namespace EmployeeAssistanceUserResolutionActor {
    export enum type {
        USER = 'user',
    }
}

